/**
 * ComingSoonStrip — the teased drills, above the library grid.
 *
 * Three greyed-out cards (the most recently teased) and a count of
 * everything coming. The cards are real drills and click through to the
 * takeover; the count is a floor plus those real rows, so it is a
 * promise rather than an inventory. See constants/comingSoon.js.
 *
 * Teased drills are pulled OUT of the main grid when this renders, so a
 * coach sees them once, here, rather than scattered dim among the
 * watchable ones. The Coming Soon tab still lists all of them.
 */
import React from "react";
import { ContentCard } from "./ContentCard";
import { GOLD } from "../constants/theme";
import { comingSoonCounts } from "../constants/comingSoon";

export function ComingSoonStrip({ items, sectionId, C, dark, onOpen, favDrills, toggleFav }) {
  const { preview, total, overflow } = comingSoonCounts(items);
  if (preview.length === 0) return null;

  return (
    <div style={{ marginBottom: 28 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 9, marginBottom: 12 }}>
        <span style={{ fontSize: 10, fontWeight: 800, letterSpacing: 1.4, textTransform: "uppercase", color: GOLD }}>
          Coming soon
        </span>
        <span style={{ fontSize: 11, fontWeight: 700, color: C.textDim, fontVariantNumeric: "tabular-nums" }}>
          {total}
        </span>
        <div style={{ flex: 1, height: 1, background: C.border }} />
      </div>

      <div className="bam-drill-grid"
        style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(220px,1fr))", gap: 16 }}>
        {preview.map((item, i) => {
          // The badge rides the last visible card rather than taking a
          // tile of its own: three pieces of real footage read better
          // than two and a number.
          const isLast = i === preview.length - 1 && overflow > 0;
          return (
            <div key={`soon-${item.id}`} style={{ position: "relative" }}>
              <ContentCard item={item} sectionId={sectionId} C={C} dark={dark}
                onClick={onOpen} favDrills={favDrills} toggleFav={toggleFav} dim />
              {isLast && (
                <div aria-hidden="true"
                  style={{ position: "absolute", inset: 0, borderRadius: 14, pointerEvents: "none",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    background: "rgba(8,9,11,0.72)" }}>
                  <div style={{ textAlign: "center" }}>
                    <div style={{ fontSize: 26, fontWeight: 800, color: GOLD, lineHeight: 1, fontVariantNumeric: "tabular-nums" }}>
                      +{overflow}
                    </div>
                    <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: 1.2, textTransform: "uppercase", color: C.textMid, marginTop: 5 }}>
                      more
                    </div>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default ComingSoonStrip;
